module.exports = __webpack_public_path__ + "assets/img/11bp_725_1.934401bd.jpg";